import { ReactElement, ReactNode } from "react";

interface PageDataPlaceholderProps {
  description?: ReactElement | string;
  icon: ReactElement;
  title: string;
  actions?: ReactNode;
}

export function PageDataPlaceholder({ actions, description, icon, title }: PageDataPlaceholderProps) {
  return (
    <div className="fixed left-1/2 top-1/2 flex w-full max-w-sm -translate-x-1/2 -translate-y-1/2 transform flex-col items-center justify-center p-8 text-center text-default-500">
      <div className="mb-4 text-5xl">{icon}</div>
      <span className="text-xl font-bold">{title}</span>
      <span className="mt-2">{description}</span>
      {actions && <div className="mt-8 flex w-full justify-center gap-2">{actions}</div>}
    </div>
  );
}
